import CheckOTPPage from "common/pages/auth/checkOTP/CheckOTP"
import SignUpFinishPage from "common/pages/auth/finish"
import SignInPage from "common/pages/auth/signIn/SignIn"
import SignUpPage from "common/pages/auth/signUp/SignUp"
import PasswordForgetPage from "common/pages/auth/passwordForget/PasswordForget"
import PasswordChangePage from "common/pages/auth/passwordChange/PasswordChange"
import GraphiQL from "common/pages/dev/graphiql"
import PermissionErrorPage from "common/pages/dev/permissionError"
import RootPage from "./applications/information/pages/Information"
import { createBrowserRouter, Outlet, RouteObject } from "react-router-dom"
import { Protected } from "utils/auth/protect"
import InitializeRoutes from "common/pages/initialize/routes";
import ReviewRoutes from "./applications/review/routes"
import SignalRoutes from "applications/signal/routes"
import ContactRoutes from "./applications/contact/routes"
import InformationRoutes from "./applications/information/routes"
import QuestEditorRoutes from "./applications/quest_editor/routes"
import InvitationAccept from "common/pages/auth/invitationAccept";
import TermPage from "common/pages/terms"
import ITGTermPage from "common/pages/terms/ITG"
import IHCTermPage from "common/pages/terms/IHC"
import { ProvideAuth } from "hooks/useAuth";
import AuthedUrqlProvider from "providers/AuthedUrqlProvider";

export const baseRoutes: RouteObject[] = [
  {
    element: (
      <ProvideAuth>
        <Outlet />
      </ProvideAuth>
    ),
    children: [
      {
        path: "auth",
        children: [
          { index: true, element: <SignInPage /> }, // it must will be sign out.
          { path: "signin", element: <SignInPage /> },
          { path: "signup", element: <SignUpPage /> },
          { path: "checkotp", element: <CheckOTPPage /> },
          { path: "finish", element: <SignUpFinishPage /> },
          { path: "passwordForget", element: <PasswordForgetPage /> },
          { path: "passwordChange", element: <PasswordChangePage /> },
          { path: "invitation_accept", element: <InvitationAccept /> },
        ],
      },
      {
        element: (
          <AuthedUrqlProvider>
            <Protected>
              <Outlet />
            </Protected>
          </AuthedUrqlProvider>
        ),
        children: [
          { index: true, path: "/", element: <RootPage /> },
        ],
      },
    ],
  },
  {
    path: "terms_of_service",
    children: [{ index: true, element: <TermPage /> }],
  },
  {
    path: "terms_of_service_ITG",
    children: [{ index: true, element: <ITGTermPage /> }],
  },
  {
    path: "terms_of_service_IHC",
    children: [{ index: true, element: <IHCTermPage /> }],
  },
  {
    path: "dev",
    element: (
      <Protected>
        <Outlet />
      </Protected>
    ),
    children: [
      { index: true, element: <GraphiQL /> },
      { path: "gql", element: <GraphiQL /> },
      { path: "permission", element: <PermissionErrorPage /> },
    ],
  },
]

export default createBrowserRouter([
  ...baseRoutes,
  ...InitializeRoutes,
  ...ReviewRoutes,
  ...SignalRoutes,
  ...ContactRoutes,
  ...InformationRoutes,
  ...QuestEditorRoutes,
  { path: "*", element: <p>Page Not Found</p> },
])
